import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`12-08-2022`}</h1>
    <ul>
      <li parentName="ul">{`managed to deploy ogbv-ml-rest to google cloud run`}
        <ul parentName="li">
          <li parentName="ul">{`very simple `}<inlineCode parentName="li">{`gcloud run deploy --memory 8G --cpu 4`}</inlineCode></li>
          <li parentName="ul">{`Query Command `}<inlineCode parentName="li">{`curl -X POST https://ogbv-ml-rest-■■■■■■-■■■■.a.run.app/predict -H 'Content-Type: application/json' -d '{"text":"■■■■ ■■■■ ■■■■■■■ ■■■■"}'`}</inlineCode></li>
          <li parentName="ul">{`It should scale up and down automatically. It will also scale down to 0 when not being used which is a huge money saver`}</li>
          <li parentName="ul">{`Since the requests to /predict go via `}<inlineCode parentName="li">{`uli-rest-api`}</inlineCode>{` i might be able to keep this public for now and still migrate uli to gke`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Conclusion for Uli`}
        <ul parentName="li">
          <li parentName="ul">{`Lets try running the entire app on cloud run. No need to involve clusters and kubernetes`}</li>
          <li parentName="ul">{`strategy`}
            <ul parentName="li">
              <li parentName="ul">{`allow unauthenticated requests to `}<inlineCode parentName="li">{`uli-rest`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`uli-rest`}</inlineCode>{` can communicate with `}<inlineCode parentName="li">{`ogbv-ml-rest`}</inlineCode>{` via `}<a parentName="li" {...{
                  "href": "https://cloud.google.com/run/docs/authenticating/service-to-service?hl=en"
                }}>{`service-to-service authentication`}</a></li>
              <li parentName="ul"><inlineCode parentName="li">{`uli-rest`}</inlineCode>{` can communicate to a cloud-sql instance`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      